module.exports = __webpack_public_path__ + "static/media/2.bc0713bc.png";